<div class="news-tiles gap-1 w-100" #tilesContainer [class.d-none]="!hasLoadableTiles()" [class.single-tile]="visibleTileContent().size === 1">
  @for (tile of tileConfig(); track $index) {
    <!-- only render visible tiles -->
    @if (tile.enabled && visibleTileContent().get($index)) {
      <div
        class="card news-card"
        #tileEl
        [class.lead]="$index === 0"
        [class.compact]="$index !== 0"
        (click)="onTileClick(visibleTileContent().get($index))">
        @if (visibleTileContent().get($index); as item) {
          <div class="media" [class.video-playoverlay]="item.imageType === 'video'">
            @if (!hasImageError($index)) {
              <img
                [ngSrc]="item.image"
                class="img-fluid w-100 h-100"
                [attr.alt]="item.title"
                [width]="$index === 0 ? 1280 : 640"
                [height]="$index === 0 ? 720 : 360"
                loading="lazy"
                decoding="async"
                (error)="onImageError($index)" />
            } @else {
              <div class="d-flex align-items-center justify-content-center w-100 h-100">
                <span class="mts-icon fs-1 notranslate" [class]="'text-' + getTileColor($index)"  translate="no">{{ getTileIcon($index) }}</span>
              </div>
            }
          </div>
          <div class="body d-flex flex-column flex-grow-1 p-2">
            <div class="d-flex justify-content-between mb-2">
              <app-pill [type]="'small'"
                [rounded]="true"
                [bgColor]="'bg-primary'"
                [fontColor]="'text-white'">
                {{ item.category }}
              </app-pill>
            
              <app-content class="d-flex align-items-center" [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'">
                {{ item.timestamp | date: 'short' }}
              </app-content>
            </div>
            <app-content [fontSize]="'fs-small'"
              [fontColor]="'text-primary'"
              [fontDecoration]="'fw-bold'"
              class="truncate-text-one-line">
              {{ item.title }}
            </app-content>
          </div>
        }
      </div>
    }
  }
</div>
